import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { Title } from "react-admin";

const Dashboard = () => {
  return (
    <Box sx={{ padding: 3 }}>
      <Title title="Dashboard" />
      <Card>
        <CardContent>
          <Typography variant="h4" component="h1" gutterBottom>
            Welcome to ATLAS
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Your security vulnerability tracking and management system.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Dashboard;
